/*
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
*/

// useSidebarLog.js
import { ref } from 'vue'

const visible = ref(false)
const context = ref(null)

export function useSidebarLog() {

    function openLog(key) {
        context.value = key
        visible.value = true
    }

    function closeLog() {
        visible.value = false
    }

    return {
        visible,
        context,
        openLog,
        closeLog
    }
}